<template>
    <SearchBar :placeholder="$t('modules.positions.topbar.searchLabel')" :hasResults="hasResults" @queryChange="setQuery">
        {{  }}
    </SearchBar>
</template>

<script>
export default {
    name: 'topbarSearchPosition',
    components: {},
    data(){
        return {
            query: ""
        }
    },
    computed: {
        searchedPositions(){
            return this.$store.getters['PositionStore/searchPositions'](this.query)
        },
        hasResults(){
            return this.searchedPositions.length > 0
        }
    },
    methods: {
        setQuery(query){
            this.query = query
            const data = {
                search_query: query,
                page: 1
            }
            this.$store.dispatch('PositionStore/indexPositions', data)
        }
    }
}
</script>


<style lang="scss">
.search_position_item{
    border-top: 1px solid #ebebeb;
    display: flex;
    a{
        padding: 18px 30px;
        display: block;
    }
    &:first-child{
        border-top: none;
    }
    .search_position_item_name{
        display: flex;
        align-items: center;

    }
}
</style>
